import {EtsyList, EtsyListing, EtsyListingStateEnum, mapEtsyListingsToListingRec} from '@coolcolduk/etsy';
import {useLocalStorageState} from '@coolcolduk/ui-common-hook';
import {useEffect, useState} from 'react';
import getAxios from '../util/axios/getAxios';
import withFirebaseToken from '../util/firebase/withFirebaseToken';

/**
 * Fetch listings by shop using the Axios client.
 * @param token - token for our api
 * @param accessToken - etsy access token
 * @param shopId - shop to fetch data from
 * @param params - Query parameters for the API.
 * @returns The listings response.
 */
export const fetchAllListingsByShop = async (
  token: string,
  shopRecordId: string,
  state?: EtsyListingStateEnum,
): Promise<EtsyList<EtsyListing>> => {
  const response = await getAxios('etsy', {token}).get<EtsyList<EtsyListing>>(`getAllListingsByShop`, {
    params: {
      state,
      shopRecordId,
    },
  });

  return response.data;
};

/**
 *
 * @param shopRecordId
 * @param state
 * @param useSaveState use local storage to save state when enabled
 * @returns
 */
export const useGetAllListingsByShop = (
  shopRecordId?: string,
  state?: EtsyListingStateEnum,
  usingSaveState = false,
) => {
  const [savedData, setSavedData] = useLocalStorageState<Record<string, EtsyListing>>(
    `useGetAllListingsByShop-${shopRecordId}-${state || 'all'}`,
    {},
  );
  const [data, setData] = useState<Record<string, EtsyListing>>({});

  useEffect(() => {
    // shop id change will reset data
    // firebase token change will reset data
    if (!usingSaveState) setData({});
  }, [shopRecordId, usingSaveState]);

  useEffect(() => {
    withFirebaseToken(async (token) => {
      if (!token || !shopRecordId) {
        if (usingSaveState) {
          setSavedData({});
        } else {
          setData({});
        }
        return;
      }
      const allListing = await fetchAllListingsByShop(token, shopRecordId, state);

      if (usingSaveState) {
        setSavedData((prev) => ({...prev, ...mapEtsyListingsToListingRec(allListing)}));
      } else {
        setData((prev) => ({...prev, ...mapEtsyListingsToListingRec(allListing)}));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, shopRecordId]);
  // return useQuery({
  //   queryKey: ["getListingsByShop", shopId, params],
  //   queryFn: () =>
  //     fetchListingsByShop(token || "", accessToken || "", shopId || "", params),
  //   staleTime: 1000 * 60 * 5, // Cache the data for 5 minutes
  //   enabled: !!shopId && !!token && !!accessToken, // Only fetch if shopId, token, and accessToken are provided
  // });
  return usingSaveState ? savedData : data;
};
